import { createContext } from 'react'

import { InventoryConnectionContextType } from './types'

export const InventoryConnectionContext = createContext<InventoryConnectionContextType>(
  {} as InventoryConnectionContextType,
)
